import React, { createContext, useContext } from 'react';

export type RemoteTool = 'landmarks' | 'goniometer';

export interface RemoteShareValue {
  /** The single shared call-window stream both tools consume; null until sharing is live. */
  stream: MediaStream | null;
  tool: RemoteTool;
  /** Landmarks overlay on/off (top-bar toggle); treated as on when absent. */
  showLandmarks?: boolean;
  /** Tools name the record they save to; the top bar shows it for the active tab. */
  reportSaveTarget?: (tool: RemoteTool, label: string) => void;
}

const RemoteShareContext = createContext<RemoteShareValue | undefined>(undefined);

export function RemoteShareProvider({ value, children }: { value: RemoteShareValue; children: React.ReactNode }) {
  return <RemoteShareContext.Provider value={value}>{children}</RemoteShareContext.Provider>;
}

export function useRemoteShare(): RemoteShareValue {
  const ctx = useContext(RemoteShareContext);
  if (!ctx) throw new Error('useRemoteShare must be used within a RemoteShareProvider');
  return ctx;
}
